const enums = { leadStatus: ['Active', 'Converted', 'Cold', 'Lost', 'Duplicate', 'Inactive'] };

export default enums;
